import React, {useState, useEffect} from 'react'

import {Row, Col} from 'antd'
import PropTypes from 'prop-types'
import {withLocalize} from 'react-localize-redux'
import {connect} from 'react-redux'

import {ReactComponent as CloseIcon} from '../../assets/icons/ic_close_blue.svg'
import {
  InformationTitle,
  CloseBtn
} from '../../pages/active_journey/ActiveJourneyStyles'
import ReflectionCard from '../cards/ReflectionCard'
import EmptyLayoutComponent from '../empty_layout/EmptyLayoutComponent'

const ReflectionsList = ({
  translate,
  activeJourney,
  completedJourney,
  onClickBack
}) => {
  // const [sortBy, setSortBy] = useState(undefined)
  const [reflections, setReflections] = useState([])
  const journey = completedJourney || activeJourney
  useEffect(() => {
    setReflections(journey?.reflections || [])
    // setSortBy(false)
  }, [journey])

  if (!journey) return null

  const renderItem = (item, index) => (
    <ReflectionCard
      key={index}
      item={item}
      bgColor='transparent'
      isCompleted={!!completedJourney}
    />
  )

  return (
    <Row gutter={[12, 24]}>
      <Col xs={20}>
        <InformationTitle>{translate('REFLECTIONS')}</InformationTitle>
      </Col>
      <Col xs={4}>
        <CloseBtn onClick={onClickBack} showBg>
          <CloseIcon />
        </CloseBtn>
      </Col>
      {reflections && reflections.length > 0 ? (
        <Col xs={24}>
          <Row gutter={[12, 24]}>
            {reflections.map((item, index) => (
              <Col md={24} lg={12} xl={8} key={index}>
                {renderItem(item, index)}
              </Col>
            ))}
          </Row>
        </Col>
      ) : (
        <EmptyLayoutComponent tag='EMPTY_REFLECTIONS' />
      )}
    </Row>
  )
}
ReflectionsList.propTypes = {
  translate: PropTypes.func.isRequired,
  onClickBack: PropTypes.func,
  activeJourney: PropTypes.object,
  completedJourney: PropTypes.object
}

ReflectionsList.defaultProps = {
  activeJourney: undefined,
  onClickBack: undefined,
  completedJourney: undefined
}
const mapStateToProps = (state) => ({
  activeJourney: state.user.active_journey
})

export default withLocalize(connect(mapStateToProps)(ReflectionsList))
